import { supabase } from '@/integrations/supabase/client';

export type AuthEvent =
  | 'auth_started'
  | 'auth_success'
  | 'auth_failed'
  | 'profile_loaded'
  | 'profile_load_failed'
  | 'redirect_started'
  | 'redirect_completed';

interface LogParams {
  event: AuthEvent;
  success?: boolean;
  userId?: string | null;
  email?: string | null;
  role?: string | null;
  errorMessage?: string | null;
  landingRoute?: string | null;
  durationMs?: number | null;
  metadata?: Record<string, unknown>;
}

/** Fire-and-forget. Never throws. Mirrors event to console for live debugging. */
export async function logAuthEvent(params: LogParams): Promise<void> {
  const payload = {
    event: params.event,
    success: params.success ?? null,
    user_id: params.userId ?? null,
    email: params.email ?? null,
    role: params.role ?? null,
    error_message: params.errorMessage ?? null,
    landing_route: params.landingRoute ?? null,
    duration_ms: params.durationMs ?? null,
    user_agent: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 500) : null,
    metadata: (params.metadata ?? {}) as never,
  };
  try {
    // Use sonner of console for visibility in dev
    // eslint-disable-next-line no-console
    console.info(`[auth] ${params.event}`, payload);
    await supabase.from('auth_events').insert(payload);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[auth-telemetry] insert failed', e);
  }
}
